import React from "react";
import "./styles/App.css";
import "./styles/Mobile.css";
import "./styles/loader.css";
import "react-toastify/dist/ReactToastify.css";
import "reactjs-popup/dist/index.css";
import "./styles/index.css";
import { ToastContainer } from "react-toastify";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AppProvider from "./contexts/AppContexts";
import PageLoader from "./components/PageLoader";
import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router-loading";
import Home from "./screens/Home";
import StatusHistory from "./screens/StatusHistory";
import ErrorPage from "./screens/error";
import NotFound from "./screens/NotFound";
import { topbar } from "react-router-loading";

topbar.config({
    autoRun: true,
    barThickness: 3,
    barColors: {
        0: 'rgb(51, 149, 255)',
        .5: 'rgb(51, 149, 255)',
        1.0: 'rgb(51, 149, 255)'
    },
    shadowBlur: 5,
    shadowColor: 'unset',
    className: 'topbar'
});

function App() {
  return (
    <BrowserRouter basename="/ticket-tracker">
      <AppProvider>
        <PageLoader />
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/tracking" element={<StatusHistory />} loading={true}/>

          <Route path="/error" element={<ErrorPage />} />

          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          draggable
        />
      </AppProvider>
    </BrowserRouter>
  );
}

export default App;
